<template>
  <!-- Modal -->
  <div
    class="modal fade"
    id="exitModal"
    tabindex="-1"
    aria-labelledby="exitModal"
    aria-hidden="true"
  >
    <div class="modal-dialog origin-pop">
    <div class="modal-content">
      <div class="modal-header">

        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body" style="padding:0px;">
        <img :src="exitPopupImage" alt="Exit Offer" />
      </div>


     <!-- <div class="modal-body">
        <h4 class="modal-title mb-3" id="exampleModalLabel">Wait! Before You Go!</h4>
        <p class="mb-3">You've nothing to lose but your weight. We want you to try our product.</p>
        <p class="mb-3"><span style="color:#f8a95c;">651,904</span> customers have already achieved their weight loss goals, and you can too! 
          If you don't experience a positive difference within <strong>30 days</strong>, you will receive a full refund! No questions asked!</p>          
        <h4 class="mb-4" style="color:#f8a95c;">Use coupon code <span style="text-decoration:underline;">10OFF</span> to get 10% off</h4>
        <div class="exit-form">
            <p>Enter your details below to receive health tips & exclusive offers.</p>
            <h4 class="mb-4" style="color:#f8a95c;">UNLOCK <span style="text-decoration:underline;">10% OFF</span></h4>
            <Form novalidate @submit="exitModal">
              
              <Field
                    rules="required"
                    type="text"
                    name="full_name"
                    class="form-control"
                    v-model="full_name"
                    placeholder="Full Name"
                  />
                  <ErrorMessage name="full_name" />
              <Field
                    rules="required|email"
                    type="text"
                    name="email"
                    class="form-control"
                    v-model="email"
                    placeholder="Email"
                  />
                   <ErrorMessage name="email" />           
            <button type="submit" class="btn btn-primary">Unlock 10% Off</button>
            </Form>
            
            <p class="small-text">By completing this form you are signing up to receive our emails and can unsubscribe at any time.</p>
        </div>
      </div>-->

    </div>
  </div>
  </div>
</template>

<script setup>
import { ref, computed, defineProps, onMounted } from "vue";
import { useRouter } from "vue-router";
import { storeToRefs } from "pinia";
import axios from "axios";
import { useLoginStore } from "../stores/login";
import { useCartStore } from "../stores/cart";
import { userLanguage } from "../stores/language";
// Validation
import { Form, Field, ErrorMessage, defineRule, configure } from "vee-validate";
import { localize } from "@vee-validate/i18n";
import * as AllRules from "@vee-validate/rules";
Object.keys(AllRules).forEach((rule) => {
  defineRule(rule, AllRules[rule]);
});

const userLanguages = userLanguage();
const { languageCode } = storeToRefs(userLanguages);

const props = defineProps(["translationText", "baseURL"]);
const cartData = useCartStore();
//const cartItemData = ref([])
const router = useRouter();
const userLogin = useLoginStore();
const quantity = ref(1);
const coupon_code = ref();
const isCoupnApply = ref(false);
const full_name = ref();
const email = ref();

const navigate = () => {
  $("#cartModal").modal("hide");
  router.push({ name: "Checkout" });
};
const navigateProduct = () => {
  $("#cartModal").modal("hide");
  router.push({ name: "Product" });
};

const exitModal = () => {
  
    const payloadData = ref({
      name:full_name.value,
      email:email.value,
    });

   const apiUrl = props.baseURL + "save/exitpopup";
   // const apiUrl = "https://cymcorp.us/management/api/v1/save/exitpopup"
    axios
      .post(apiUrl, payloadData.value)
      .then((response) => {
        
        if (response.data.message) {
          swal({
            position: "top-end",
            icon: "success",
            title: response.data.message,
            button: false,
            timer: 2500,
          });
          window.$("#exitModal").modal("hide");
          //  router.push({
          //   name: "Checkout",
          //   //params: { sluguser: userLogin.getUserUrlName },
          // });
          
        } else {
          swal({
            position: "top-end",
            icon: "error",
            title: response.data.error,
            button: false,
            timer: 2500,
          });
          
        }

       
      })
      .catch((error) => {
        swal({
            position: "top-end",
            icon: "error",
            title: "There is an error. Please try again.",
            button: false,
            timer: 2500,
          });
        console.error("Error fetching data:", error);
      });

  
};
const removeApplyCode = () => {
  cartData.resetApplyCoupon();
  coupon_code.value = "";
  isCoupnApply.value = false;
};
const decreaseQty = () => {
  if (quantity.value > 1) {
    quantity.value--;
  }
};

const increaseQty = () => {
  quantity.value++;
};
const cartItem = {
  id: 1,
};
const openCartModal = () => {
  cartData.addToCart(cartItem);
  $("#cartModal").modal("show");
};
onMounted(() => {
  console.log("cartItemData on mounted ");
});
const exitPopupImage = computed(() => {
  const lang = languageCode.value || 'en';
  if (lang === 'fr') return '/assets/images/checkout/exitpopupdiscount.png?ver=1.2';
  if (lang === 'es') return '/assets/images/checkout/exitpopupdiscount.png?ver=1.2';
  return '/assets/images/checkout/exitpopupdiscount.png?ver=1.2'; // Default (English)
});
</script>
